import NotFoundPage from "@/app/404";
import Login from "@/app/auth/login";
import Signup from "@/app/auth/signup/signup.page";
import SignupInvitePage from "@/app/auth/signup/signup-org-invite.page.tsx";
import FinishSignupPage from "@/app/auth/signup/finish-signup.page.tsx";
import VendorRelationshipInvitePage from "@/app/auth/vendor-relationship-invite/vendor-relationship-invite.page.tsx";
import ForgotPassword from "@/app/auth/forgot-password";
import ResetPassword from "@/app/auth/reset-password";
import { Navigate } from "react-router";

type AuthRoute = { path: string; element: React.ReactNode; special?: boolean; signedInToo?: boolean };

export const auth_routes: AuthRoute[] = [
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword />,
  },
  {
    path: "/reset-password",
    element: <ResetPassword />,
    special: true,
  },
  {
    path: "/signup/invite",
    element: <SignupInvitePage />,
    signedInToo: true,
  },
  {
    path: "/signup/finish",
    element: <FinishSignupPage />,
  },
  {
    path: "/invite/vendor-relationship",
    element: <VendorRelationshipInvitePage />,
    signedInToo: true,
  },
  {
    path: "/signup",
    element: <Signup />,
  },
  {
    path: "/auth/login",
    element: <Navigate to="/login" />,
  },
  {
    path: "*",
    element: <NotFoundPage />,
  },
];
